import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 'all';

const personalTemplateViewSlice = createSlice({
	name: 'personalTemplateView',
	initialState,
	reducers: {
		setPersonalTemplateView: (state, action) => {
			return action.payload;
		}
	}
});

export const { setPersonalTemplateView } = personalTemplateViewSlice.actions;

export default personalTemplateViewSlice.reducer;
